<template>
	<section class="lead" v-html="copy"></section>
</template>

<script>
import PointerHoverMixin from '@/mixins/pointerHover';
export default {
	mixins: [PointerHoverMixin],
	props: {
		copy: String,
	},
	mounted() {
		this.addLinksListener();
	},
	updated() {
		this.addLinksListener();
	},
	beforeDestroy() {
		this.removeLinksListener();
	}
}
</script>

<style lang="scss" scoped>
.lead {
	@include moduleSpacing;
	@include fontLeadIn;
	@include textFormat;
	width: 100%;


	&::v-deep * {
		@include fontLeadIn;
	}

	@include mq($from: m) {
		@include gridColumn(m, 15, 1, false, true);
	}

	@include mq($from: xl) {
		@include gridColumn(xl, 13, 2, false, true);
	}
}

</style>